import React, { useEffect, useState, useRef } from 'react';
import { NavLink, Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { SearchMovies } from '../Redux/action';
import Offcanvas from 'react-bootstrap/Offcanvas'
import Navbar from './nav';
import { mock } from './mock';
const Header = (props) => {
    const movies = useSelector(state => state.DetailMovie);
    const searchMVs = useSelector(state => state.SearchMV);
    const searchMV = searchMVs.searchMV
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [navPhone, setnavPhone] = useState(true);
    const [show, setShow] = useState(false);
    const navbar = mock.header
    const inputref = useRef(null)
    const onSearch = (e) => {
        inputref.current.style.border = "1px solid #f9ac02";
        setSearch(e.target.value)
    }
    const Reset = () => {
        inputref.current.style.border = "none";
        setSearch('');
    }
    const handleSearch = () => {
        setnavPhone(false);
        setShow(true)
    }
    const handleNav = () => {
        setnavPhone(true);
        setShow(true)
    }
    const handleClose = () => {
        setnavPhone(true);
        setShow(false);
    }
    useEffect(() => {
        if (search) {
            const timer = setTimeout(() => {
                dispatch(SearchMovies(search));
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [search, dispatch]);
    const handleShow = () => setShow(true);
    const localStor = localStorage.getItem('theme');
    return (
        <>
            <nav className="header-main navbar navbar-expand-lg shadow-sm fixed-top">
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img src={process.env.PUBLIC_URL + `${localStor === 'dark' ? "/logo.png" : "/logodark.png"}`} alt="Logo" style={{ maxWidth: '200px' }} />
                    </Link>
                    <div className="d-none d-sm-block ">
                        <ul className="navbar-nav mb-2 mb-lg-0 ">
                            {navbar?.map((item, index) => {
                                return <li className="nav-item" key={index}>
                                    <NavLink activeClassName="active" className="nav-link" to={item.url}>{item.navbar}</NavLink>
                                </li>
                            })}
                        </ul>
                    </div>
                    <div className="d-block d-sm-block">
                        <span onClick={handleSearch} className="navbar-toggler border-0" role="button" data-bs-toggle="offcanvas" href="#offcanvasNav">
                            <i className="bi bi-search"></i>
                        </span>
                        <span onClick={handleNav} className="navbar-toggler" role="button" data-bs-toggle="offcanvas" href="#offcanvasNav">
                            <i className={`p-2 m-0 rounded-2 h5  ${show ? 'bi bi-x-lg' : 'bi bi-grid-3x3-gap-fill'}`}></i>
                        </span>
                        <span className="h5 px-2 m-0 d-inline-block d-sm-none" role="button" onClick={props.toggleTheme}>{props.theme === "dark" ? <i className="bi bi-moon"></i> : <i class="bi bi-brightness-high"></i>}</span>
                    </div>
                    <div className="collapse navbar-collapse d-flex justify-content-end d-none d-sm-none" >
                        <div className="d-flex ml-3">
                            <div className="searchbar" id="Movies2" ref={inputref}>
                                <input className="search_input" type="text" name="search" placeholder="Search..." value={search} onChange={onSearch} />
                                <Link to="#" className="search_icon border border-warning" onClick={Reset}>
                                    {search ?
                                        <i className="bi bi-x-circle"></i> :
                                        <i className="bi bi-search" ></i>
                                    }
                                </Link>
                            </div>
                            <ul className={`dropdown-search rounded-3 p-2 dropdown-menu ${search ? "d-block dropdown-search scrolling-bar" : "dropdown-search "}`}>
                                {searchMV ?
                                    <>
                                        {searchMV && searchMV.map((mv, index) => {
                                            return (
                                                <>
                                                    <div className="row p-1" key={index}>
                                                        <Link className="list-movie d-flex text-decoration-none" to={`/detail/movies/${mv.id}`}>
                                                            <div className="col-2 my-2">
                                                                <img className="img-fluid rounded" src={mv.medium_cover_image} alt="Cover" />
                                                                <span className="btn-play" key={mv.id}><i className="bi bi-play-fill play_button"></i></span>
                                                            </div>
                                                            <div className="col-10 my-2 p-2">
                                                                <h6>{mv.title}</h6>
                                                                <p>{mv.year}</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </>
                                            )
                                        })}
                                    </> : <h6 className="m-4"><i class="bi bi-emoji-laughing text-warning"></i> No Movies </h6>
                                }
                                {
                                    searchMVs.LoadingSearch === true &&
                                    <p className="m-0 p-2">
                                        <span className="spinner-border spinner-border-sm mr-2 text-warning" role="status" aria-hidden="true"></span>
                                        &nbsp; Searching...
                                    </p>
                                }
                            </ul>
                        </div>
                        <span className="h5 px-2 m-0" role="button" onClick={props.toggleTheme}>{props.theme === "dark" ? <i className="bi bi-moon"></i> : <i class="bi bi-brightness-high"></i>}</span>
                        <span style={{ width: '36px' }}>
                            {
                                movies.header === true &&
                                <span className="d-none d-sm-block d-sm-none d-md-block" onClick={handleShow} type="button">
                                    <i className={`p-2 m-0 bg-warning rounded-2 text-white h5 ${show ? 'bi bi-x-lg' : 'bi bi-grid-3x3-gap-fill'}`}></i>
                                </span>
                            }
                        </span>

                    </div>
                </div>
                <Offcanvas show={show} onHide={handleClose} className="header-main">
                    <Offcanvas.Header className="shadow-sm" closeButton>
                        <Offcanvas.Title>{navPhone ? 'Menu' : 'Search'}</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body className=" scrolling-bar-res  pt-0 ">
                        {navPhone ?
                            <>
                                <div className="d-md-none d-lg-none">
                                    {navbar?.map((item, index) => {
                                        return <>
                                            <span className="nav-item my-2 d-inline-block border mx-2 p-1 rounded-pill" key={index} onClick={handleClose}>
                                                <NavLink activeClassName="active" className="nav-link d-inline" to={item.url}><i className={item.icon}></i> {item.navbar}</NavLink>
                                            </span>
                                        </>
                                    })}
                                </div>
                                <Navbar data={show} clickHandle={handleClose} />
                            </>
                            :
                            <>
                                <div className="searchbar p-1 mt-2" ref={inputref}>
                                    <input style={{ width: '80%' }} className="search_input" type="text" name="search" placeholder="Search..." value={search} onChange={onSearch} />
                                    <Link to="#" className="search_icon border border-warning" onClick={Reset}>
                                        {search ?
                                            <i className="bi bi-x-circle"></i> :
                                            <i className="bi bi-search" ></i>
                                        }
                                    </Link>
                                </div>
                                <ul style={{ width: '92%', top: '134px' }} className={`dropdown-search rounded-3 p-2 dropdown-menu border-0 ${search ? "d-block dropdown-search scrolling-bar-res" : "dropdown-search"}`}>
                                    {searchMV ?
                                        <>
                                            {searchMV && searchMV.map((mv, index) => {
                                                return (
                                                    <>
                                                        <div className="row p-1" key={index}>
                                                            <Link onClick={handleClose} className="list-movie d-flex text-decoration-none" to={`/detail/movies/${mv.id}`}>
                                                                <div className="col-2 my-2">
                                                                    <img className="img-fluid rounded" src={mv.medium_cover_image} alt="Cover" />
                                                                    <span className="btn-play" key={mv.id}><i className="bi bi-play-fill play_button"></i></span>
                                                                </div>
                                                                <div className="col-10 my-2 p-2">
                                                                    <h6>{mv.title}</h6>
                                                                    <p>{mv.year}</p>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </> : <h5 className="m-4"><i className="bi bi-emoji-laughing text-warning"></i> No Movies </h5>
                                    }
                                    {
                                        searchMVs.LoadingSearch === true &&
                                        <p className="m-0 p-2">
                                            <span className="spinner-border spinner-border-sm mr-2 text-warning" role="status" aria-hidden="true"></span>
                                            &nbsp; Searching...
                                        </p>
                                    }
                                </ul>
                            </>
                        }
                    </Offcanvas.Body>
                </Offcanvas>
            </nav>
            <br />
        </>
    );
}
export default Header;